import { useTranslation } from 'react-i18next';

/**
 * ADR 0016 D24 (#910): short discussion guidelines, linked from every thread -- state facts with
 * sources, mark questions and opinions as such. A disclosure, so it costs one line until opened.
 */
export function DiscussionGuidelines() {
  const { t } = useTranslation();
  return (
    <details className="discussion-guidelines">
      <summary>{t('discussions.guidelines.summary')}</summary>
      <ul>
        <li>{t('discussions.guidelines.facts')}</li>
        <li>{t('discussions.guidelines.data')}</li>
        <li>{t('discussions.guidelines.opinions')}</li>
        <li>{t('discussions.guidelines.respect')}</li>
      </ul>
    </details>
  );
}
